import { render, staticRenderFns } from "./TreatmentCustomerTable.vue?vue&type=template&id=861b647c&scoped=true"
import script from "./TreatmentCustomerTable.vue?vue&type=script&lang=js"
export * from "./TreatmentCustomerTable.vue?vue&type=script&lang=js"
import style0 from "./TreatmentCustomerTable.vue?vue&type=style&index=0&id=861b647c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861b647c",
  null
  
)

export default component.exports